import suntagoBusImg from 'assets/images/amenitiesAndAttractions/suntagoBus.jpg'
import suntagoBusImgMobile from 'assets/images/amenitiesAndAttractions/suntagoBusMobile.jpg'
import { SUNTAGO_BUS_PRICE } from 'constants/prices'
import { BusTicketCreator } from 'routes/Upsell/Bus/components/BusTicketCreator'
import Attraction from 'components/shared/Attraction'
import { useIntl } from 'react-intl'
import { useEffect, useState } from 'react'
import { TransportModal } from 'routes/Upsell/Bus/modals/TransportModal/TransportModal'
import { useTransport } from 'store/transport-slice/hooks'
import { scrollToTop } from 'helpers/animateScroll'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { useAutoScroll } from 'utils/hooks'
import { addRoute } from 'store/transport-slice'
import { useCart } from 'store/cart-slice/hooks'

export const BusTicketAttraction = () => {
    const shouldEditorBeOpened =
        window.location.href.includes('#manage-transport')
    const { routes } = useAppSelector((state) => state.transport)
    const dispatch = useAppDispatch()
    const { formatMessage } = useIntl()
    const { removeTransportFromCart, isTransportProcessing, getInitialData } =
        useTransport(null)
    const { calculateScroll, animatePendingScroll, scrollIndex } =
        useAutoScroll()
    const { isStepEmpty } = useCart()

    const [isTransportModalOpen, setIsTransportModalOpen] = useState(false)
    const [isDropdownOpen, setIsDropdownOpen] = useState(false)

    const handleToggleTransportModal = () => {
        setIsTransportModalOpen(!isTransportModalOpen)
    }

    const handleRemoveUpsell = () => {
        removeTransportFromCart().then((isSuccess) => {
            if (isSuccess) {
                scrollToTop()
                setIsDropdownOpen(false)
            }
            window.history.pushState(
                {},
                document.title,
                window.location.pathname
            )
        })
    }

    const sectionId = 'transport-box'

    const handleAddUpsell = () => {
        dispatch(addRoute(getInitialData()))
        calculateScroll({
            trigerringSection: 'transport',
            trigerringAction: 'show',
        })
    }

    const handleButtonClick = () => {
        isDropdownOpen ? handleRemoveUpsell() : handleAddUpsell()
    }

    useEffect(() => {
        if (routes.length === 0) {
            setIsDropdownOpen(false)
        } else setIsDropdownOpen(true)
    }, [routes.length])

    useEffect(() => {
        if (!isStepEmpty('upsell')) return
        setIsDropdownOpen(false)
    }, [])

    useEffect(() => {
        animatePendingScroll(sectionId)
    }, [scrollIndex])

    const areSubmittedTickets = routes.some((route) => route.isSubmitted)

    useEffect(() => {
        if (isDropdownOpen) return
        shouldEditorBeOpened && setIsDropdownOpen(true)
        shouldEditorBeOpened && handleAddUpsell()
    }, [shouldEditorBeOpened])

    return (
        <>
            <Attraction
                isAvailableOnline={true}
                title="Suntago Bus"
                price={SUNTAGO_BUS_PRICE}
                isPriceFrom={true}
                hasSmallContentPaddingTop
                details={[
                    formatMessage({
                        id: 'upsells.transport.advantage_coaches',
                        defaultMessage: '_',
                    }),
                    formatMessage({
                        id: 'upsells.transport.advantage_routes',
                        defaultMessage: '_',
                    }),
                    formatMessage({
                        id: 'upsells.transport.advantage_seating',
                        defaultMessage: '_',
                    }),
                ]}
                images={[suntagoBusImgMobile, suntagoBusImg]}
                creator={<BusTicketCreator />}
                handleModalOpening={handleToggleTransportModal}
                isButtonLoading={isTransportProcessing}
                isDropdownOpen={isDropdownOpen}
                handleButtonClick={handleButtonClick}
                isAdded={areSubmittedTickets}
                id={sectionId}
            />

            <TransportModal
                isOpened={isTransportModalOpen}
                closeModal={handleToggleTransportModal}
            />
        </>
    )
}

BusTicketAttraction.displayName = 'BusTicketAttraction'
